import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Link from '@components/link'
import { Image } from '@components/atoms'
import {
  IconFlag,
  IconMarker,
} from '@components/atoms/icons'
import DateRange from '@components/atoms/date-range-new'
import { CtaText } from '@components/atoms/cta-arrow'
import useHover from '@hooks/useHover'
import useStyles from './card-showcase-event.styles'

const CardShowcaseEvent = (props) => {
  const {
    headline,
    image,
    course,
    location,
    startDate,
    endDate,
    logo,
    heroImage,
  } = props

  const [hoverRef, isHovered] = useHover()
  const styles = useStyles()

  const url = (image && image.url) || (heroImage && heroImage.url) || (logo && logo.url)

  return (
    <Link anchorProps={{ ref: hoverRef }} {...props} className={styles.root} title={headline}>
      <Box className={styles.cardWrapper}>
        {url && <Image className={styles.image} src={`${url}?h=200&w=600&fit=fill&fl=progressive&q=80`} alt={`View page for ${headline}`} />}
        <Box className={styles.cardInfo} aria-hidden="true">
          <Box className={styles.logoWrapper}>
            {logo?.url && <Image className={styles.logo} src={`${logo.url}?fm=jpg&h=200&w=200&fit=fill&fl=progressive&q=80`} alt={`${headline} logo`} />}
          </Box>
          <Box className={styles.headlineWrapper}>
            <Typography variant="h6" className={styles.headline}>{headline}</Typography>
            <Box className={styles.dateRange}>
              <DateRange startDate={startDate} endDate={endDate} />
            </Box>
          </Box>
          <Box className={styles.detailsWrapper}>
            <Box className={styles.locationWrapper}>
              {course && (
                <div className={styles.field}><IconFlag className={styles.icon} viewBox="6 0 24 24" />
                  <Typography variant="caption" className={styles.fieldText}>{course}</Typography>
                </div>
              )}
              {location && (
                <div className={styles.field}><IconMarker className={styles.icon} viewBox="6 0 24 24" />
                  <Typography variant="caption" className={styles.fieldText}>{location}</Typography>
                </div>
              )}
            </Box>
            <CtaText hovered={isHovered} variant="subtitle2" className={styles.cta}>
              View Event
            </CtaText>
          </Box>
        </Box>
      </Box>
    </Link>
  )
}

CardShowcaseEvent.propTypes = {
  headline: PropTypes.string,
  image: PropTypes.shape({
    url: PropTypes.string,
  }),
  logo: PropTypes.shape({
    url: PropTypes.string,
  }),
  slug: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  location: PropTypes.string,
  course: PropTypes.string,
  heroImage: PropTypes.shape({
    url: PropTypes.string,
  }),
}

export default CardShowcaseEvent
